import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetGeneralMessages = () =>
  axios.get(`${apiPaths.worklistBase}/messages`, { params: { worklist_type: 'general' } });

const onUpdateGeneralMessage = (message) => axios.put(`${apiPaths.worklistBase}/messages/${message.id}`, message);

const onDeleteGeneralMessage = (messageId) => axios.delete(`${apiPaths.worklistBase}/messages/${messageId}`);

export { onGetGeneralMessages, onUpdateGeneralMessage, onDeleteGeneralMessage };
